import styles from './ccf-agent-settings-send-icon.module.scss';
import { SvgIcon, SvgIconProps } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfAgentSettingsSendIconProps extends SvgIconProps {}
/**
 * CcfAgentSettingsSendIcon component
 * @param props - CcfAgentSettingsSendIconProps
 * @example <CcfAgentSettingsSendIcon />
 * @returns JSX Element
 */

export function CcfAgentSettingsSendIcon(props: CcfAgentSettingsSendIconProps) {
  return (
    <SvgIcon
    width="32"
    height="48"
      viewBox="0 0 24 24"
      sx={{ fontSize: '32px', fill: '#757575', paddingTop: '8px' }}
      {...props}
    >
        <g id=".send-03">
          <path
            id="Icon (Stroke)"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M3.0292 2.11552C3.03754 2.11928 3.04589 2.12303 3.05423 2.12679L15.617 7.78C15.7881 7.85698 15.9598 7.93418 16.0937 8.00954C16.218 8.07953 16.4582 8.22462 16.595 8.50132C16.7503 8.81558 16.7503 9.1843 16.595 9.49855C16.4582 9.77526 16.218 9.92035 16.0937 9.99034C15.9598 10.0657 15.7881 10.1429 15.617 10.2199L3.03349 15.8825C2.85786 15.9615 2.68291 16.0403 2.5354 16.0914C2.40018 16.1382 2.12741 16.2241 1.82559 16.1399C1.48475 16.0447 1.20854 15.7948 1.07993 15.4651C0.966046 15.1732 1.02429 14.8932 1.05743 14.754C1.09359 14.6021 1.15453 14.4202 1.21571 14.2375L2.95975 9.02789L1.21897 3.78315C1.21609 3.77447 1.2132 3.76578 1.21032 3.7571C1.14981 3.57489 1.08948 3.39323 1.05379 3.24155C1.02103 3.1023 0.963741 2.82283 1.07794 2.53165C1.20699 2.2026 1.48318 1.95334 1.8237 1.85859C2.12502 1.77475 2.39717 1.8603 2.53234 1.90712C2.67958 1.95812 2.85413 2.0367 3.0292 2.11552ZM2.75021 3.63486L4.28201 8.24994H7.87532C8.28954 8.24994 8.62532 8.58572 8.62532 8.99994C8.62532 9.41415 8.28954 9.74994 7.87532 9.74994H4.29985L2.75568 14.3626L14.6727 8.99994L2.75021 3.63486Z"
            fill="#757575"
          ></path>
        </g>
    </SvgIcon>
  );
}

export default CcfAgentSettingsSendIcon;
